var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "数据迁移",
        visible: _vm.dialogVisible,
        width: "680px",
        "close-on-click-modal": false,
        "custom-class": "migration-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.close,
      },
    },
    [
      _c("div", { staticClass: "step-indicator" }, [
        _c(
          "div",
          {
            staticClass: "step-item",
            class: { active: _vm.currentStep >= 1, done: _vm.currentStep > 1 },
          },
          [
            _c("div", { staticClass: "step-circle" }, [
              _vm.currentStep <= 1
                ? _c("span", [_vm._v("1")])
                : _c("i", { staticClass: "el-icon-check" }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "step-label" }, [_vm._v("下载模板")]),
          ]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "step-line",
          class: { active: _vm.currentStep >= 2 },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "step-item",
            class: { active: _vm.currentStep >= 2, done: _vm.currentStep > 2 },
          },
          [
            _c("div", { staticClass: "step-circle" }, [
              _vm.currentStep <= 2
                ? _c("span", [_vm._v("2")])
                : _c("i", { staticClass: "el-icon-check" }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "step-label" }, [_vm._v("填写数据")]),
          ]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "step-line",
          class: { active: _vm.currentStep >= 3 },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "step-item", class: { active: _vm.currentStep >= 3 } },
          [
            _c("div", { staticClass: "step-circle" }, [_vm._v("3")]),
            _vm._v(" "),
            _c("span", { staticClass: "step-label" }, [_vm._v("上传迁移")]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: { model: _vm.form, "label-width": "90px", rules: _vm.rules },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentStep === 1,
                  expression: "currentStep === 1",
                },
              ],
              staticClass: "step-content",
            },
            [
              _c("div", { staticClass: "step-header" }, [
                _c("div", { staticClass: "step-icon" }, [
                  _c("i", { staticClass: "el-icon-document" }),
                ]),
                _vm._v(" "),
                _c("h3", [_vm._v("下载迁移模板")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "请先下载官方提供的迁移模板，按照表头格式填写您的员工数据"
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tips-card" }, [
                _c("div", { staticClass: "tips-header" }, [
                  _c("i", { staticClass: "el-icon-warning-outline" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("填写说明")]),
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "tips-list" }, [
                  _c("li", [
                    _c("span", { staticClass: "field-name" }, [
                      _vm._v("手机号"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "field-desc" }, [
                      _vm._v("必填，11位手机号码，用于创建员工账户"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", { staticClass: "field-name" }, [
                      _vm._v("openid"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "field-desc" }, [
                      _vm._v("必填，用户唯一标识，用于关联微信用户"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", { staticClass: "field-name" }, [_vm._v("姓名")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "field-desc" }, [
                      _vm._v("选填，员工姓名"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", { staticClass: "field-name" }, [_vm._v("公司")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "field-desc" }, [
                      _vm._v("选填，相同公司名称会归入同一批次"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", { staticClass: "field-name" }, [
                      _vm._v("余额*"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "field-desc" }, [
                      _vm._v("必填，福豆余额，数字格式（如：100.00）"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", { staticClass: "field-name" }, [
                      _vm._v("积分商城余额"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "field-desc" }, [
                      _vm._v("选填，积分商城积分余额，整数格式（如：50）"),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "action-row" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "download-btn",
                      attrs: {
                        type: "primary",
                        size: "medium",
                        icon: "el-icon-download",
                      },
                      on: { click: _vm.downloadTemplate },
                    },
                    [_vm._v("\n          下载迁移模板\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "next-btn",
                      attrs: { size: "medium" },
                      on: { click: _vm.nextStep },
                    },
                    [
                      _vm._v("\n          我已填写完成，下一步\n          "),
                      _c("i", { staticClass: "el-icon-arrow-right" }),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentStep === 2,
                  expression: "currentStep === 2",
                },
              ],
              staticClass: "step-content",
            },
            [
              _c("div", { staticClass: "step-header" }, [
                _c("div", { staticClass: "step-icon step-icon--success" }, [
                  _c("i", { staticClass: "el-icon-edit-outline" }),
                ]),
                _vm._v(" "),
                _c("h3", [_vm._v("上传迁移数据")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("选择已填写好的迁移文件，并关联目标小程序和福卡账户"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "form-item-custom",
                  attrs: { label: "目标小程序：", prop: "appId" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "请选择目标小程序",
                        filterable: "",
                        clearable: "",
                        size: "medium",
                      },
                      on: { change: _vm.onAppChange },
                      model: {
                        value: _vm.form.appId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "appId", $$v)
                        },
                        expression: "form.appId",
                      },
                    },
                    _vm._l(_vm.customerList, function (item) {
                      return _c(
                        "el-option",
                        {
                          key: item.id,
                          attrs: { label: item.appName, value: item.id },
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(_vm._s(item.appName)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "right",
                                color: "#8492a6",
                                "font-size": "12px",
                              },
                            },
                            [_vm._v("ID: " + _vm._s(item.id))]
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "form-item-custom",
                  attrs: { label: "福豆卡：", prop: "fuCardId" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "请选择福豆卡",
                        filterable: "",
                        clearable: "",
                        disabled: !_vm.form.appId,
                        size: "medium",
                      },
                      model: {
                        value: _vm.form.fuCardId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "fuCardId", $$v)
                        },
                        expression: "form.fuCardId",
                      },
                    },
                    _vm._l(_vm.fudouCardList, function (item) {
                      return _c(
                        "el-option",
                        {
                          key: item.id,
                          attrs: {
                            label:
                              item.cardName +
                              (item.innerRemark
                                ? " - " + item.innerRemark
                                : ""),
                            value: item.id,
                          },
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(_vm._s(item.cardName)),
                          ]),
                          _vm._v(" "),
                          item.innerRemark
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "right",
                                    color: "#8492a6",
                                    "font-size": "12px",
                                  },
                                },
                                [_vm._v(_vm._s(item.innerRemark))]
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "form-item-custom",
                  attrs: { label: "迁移备注：" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder:
                        "请输入迁移备注信息（选填），用于区分不同批次的迁移记录",
                      maxlength: "200",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "form-item-custom",
                  attrs: { label: "上传文件：", prop: "file" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "upload-area",
                      class: {
                        "has-file": _vm.uploadedFile,
                        dragover: _vm.isDragover,
                      },
                      on: {
                        click: _vm.triggerUpload,
                        dragover: function ($event) {
                          $event.preventDefault()
                          _vm.isDragover = true
                        },
                        dragleave: function ($event) {
                          _vm.isDragover = false
                        },
                        drop: function ($event) {
                          $event.preventDefault()
                          return _vm.handleDrop($event)
                        },
                      },
                    },
                    [
                      _c("input", {
                        ref: "fileInputRef",
                        staticStyle: { display: "none" },
                        attrs: { type: "file", accept: ".xlsx, .xls, .csv" },
                        on: { change: _vm.handleFileChange },
                      }),
                      _vm._v(" "),
                      !_vm.uploadedFile
                        ? [
                            _c("div", { staticClass: "upload-placeholder" }, [
                              _c("i", {
                                staticClass: "el-icon-upload2 upload-icon",
                              }),
                              _vm._v(" "),
                              _c("p", { staticClass: "upload-text" }, [
                                _vm._v("将文件拖到此处，或"),
                                _c("span", { staticClass: "link" }, [
                                  _vm._v("点击上传"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "upload-hint" }, [
                                _vm._v("支持 .xlsx、.xls、.csv 格式"),
                              ]),
                            ]),
                          ]
                        : [
                            _c(
                              "div",
                              { staticClass: "file-preview" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "file-icon",
                                    class: _vm.fileIconClass,
                                  },
                                  [_c("i", { class: _vm.fileIcon })]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "file-info" }, [
                                  _c("p", { staticClass: "file-name" }, [
                                    _vm._v(_vm._s(_vm.uploadedFile.name)),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "file-size" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatFileSize(
                                          _vm.uploadedFile.size
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "remove-btn",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.removeFile($event)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "el-icon-close" })]
                                ),
                              ],
                              1
                            ),
                          ],
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "action-row" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "prev-btn",
                      attrs: { size: "medium" },
                      on: { click: _vm.prevStep },
                    },
                    [
                      _c("i", { staticClass: "el-icon-arrow-left" }),
                      _vm._v("\n          上一步\n        "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "next-btn",
                      attrs: {
                        type: "primary",
                        size: "medium",
                        disabled: !_vm.form.fuCardId || !_vm.uploadedFile,
                      },
                      on: { click: _vm.nextStep },
                    },
                    [
                      _vm._v("\n          确认迁移\n          "),
                      _c("i", { staticClass: "el-icon-arrow-right" }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentStep === 3,
                  expression: "currentStep === 3",
                },
              ],
              staticClass: "step-content",
            },
            [
              _c("div", { staticClass: "step-header" }, [
                _c(
                  "div",
                  { staticClass: "progress-ring-wrapper" },
                  [
                    _c("el-progress", {
                      attrs: {
                        type: "circle",
                        percentage: _vm.uploadProgress,
                        status: _vm.uploadProgressStatus || undefined,
                        "stroke-width": 8,
                        width: 120,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("h3", [_vm._v(_vm._s(_vm.uploadStatusText))]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.uploadStatusDesc))]),
              ]),
              _vm._v(" "),
              _vm.uploadSuccess
                ? _c("div", { staticClass: "success-panel" }, [
                    _c("div", { staticClass: "success-icon" }, [
                      _c("i", { staticClass: "el-icon-success" }),
                    ]),
                    _vm._v(" "),
                    _c("h4", [_vm._v("迁移完成！")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("数据已成功迁移，可在「客户操作记录」中查看详情"),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.uploadFailed
                ? _c("div", { staticClass: "fail-panel" }, [
                    _c("div", { staticClass: "fail-icon" }, [
                      _c("i", { staticClass: "el-icon-error" }),
                    ]),
                    _vm._v(" "),
                    _c("h4", [_vm._v("迁移失败")]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.failReason))]),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.currentStep < 3
        ? _c(
            "div",
            {
              staticClass: "dialog-footer-custom",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:customer:integral:migration:list"],
                      expression: "['admin:customer:integral:migration:list']",
                    },
                  ],
                  attrs: {
                    type: "warning",
                    size: "small",
                    plain: "",
                    icon: "el-icon-document",
                  },
                  on: { click: _vm.openLogDialog },
                },
                [_vm._v("\n      查看上传日志\n    ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "footer-right" },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.close } },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.uploadSuccess
        ? _c(
            "div",
            {
              staticClass: "dialog-footer-custom",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "medium" },
                  on: { click: _vm.handleDone },
                },
                [_vm._v("完成")]
              ),
            ],
            1
          )
        : _vm.uploadFailed
        ? _c(
            "div",
            {
              staticClass: "dialog-footer-custom",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "medium" },
                  on: { click: _vm.resetMigrationState },
                },
                [
                  _c("i", { staticClass: "el-icon-arrow-left" }),
                  _vm._v("\n      返回上一页\n    "),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "footer-right" },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.close } },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("MigrationLogDialog", {
        ref: "MigrationLogDialogRef",
        attrs: { customerId: _vm.currentCustomerId },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }